import React, { FC } from 'react'
import ButtonComponent, { ButtonComponentProps } from '../Button/ButtonComponent'

const RoundedButtonComponent: FC<ButtonComponentProps> = (props) => {
  return (
    <ButtonComponent
      border="1px solid #42474E"
      borderRadius="20px"
      color="var(--secondary)"
      textTransform='initial'
      width="100%"
      {...props}
    />
  )
}

export default RoundedButtonComponent
